import axios from 'axios';

export default{
  //获取物流减排
  getReduct() {
    return axios.get('/logist/reduct/list');
  },
  //获取物流减排
  getReductDown() {
    return axios.get('/logist/reduct/yearList');
  },
  //获取渠道分布
  getChannel() {
    return axios.get('/sale/channel/list');
  },
} 